import React, { useContext } from 'react';
import { filter } from 'lodash';
import Select from "react-select";
import { IndexData } from "../../common/index-context";
import { baseContext } from '../../../respondent/common/contexts';

const FiltersDropdown = ({ options }) => {
  const { selectedOptions, setSelectedOptions, selectedBsg, loadData } = useContext(IndexData);
  const { additionalSubgroups } = useContext(baseContext);

  const exists = (data) => filter(data, (item) => {
    return item.value === 0;
  });

  const cleared = (options) => {
    return !exists(options).length;
  };

  const onApplyFilter = (data) => {
    const filters = { selected_bsg: selectedBsg, selected_sub_groups: data };
    loadData(filters, { additional_subgroups: additionalSubgroups }, null, null, { fromUrl: true }, (data) => {
    });
  };

  const handleSelect = (data, selected) => {
    setSelectedOptions(data);
    onApplyFilter(data);
  };

  return (
    <Select
      className="react-select-container"
      classNamePrefix="react-select"
      options={ options }
      placeholder="Select filter"
      value={ selectedOptions }
      onChange={ handleSelect }
      isSearchable
      isMulti
      isClearable={ cleared(selectedOptions) }
    />
  );
};

export default FiltersDropdown;
